import { UserRole } from './ApiClient';

export const SuperUserRole: UserRole = 'SuperUser';
